<div class="ui-g">
  <div class="ui-g-12">
    <div class="card card-w-title">
      <h1>Mobile Branding</h1>
      <div class="ui-grid ui-grid-responsive ui-fluid">
        <div class="ui-g-12">
          <div class="ui-grid-col-2"><label for="loginScreenLogo">Login screen logo</label></div>
          <div class="ui-grid-col-4">
            <p-fileUpload
              id="loginScreenLogo"
              name="myfile[]"
              maxFileSize="1000000"
              accept="image/*"
              url="{{ hostname }}/api/supplier/uploadscreenlogo"
              chooseLabel="Choose"
              uploadLabel="Upload"
              cancelLabel="Cancel"
            >
            </p-fileUpload>
          </div>
        </div>
      </div>
      <div class="ui-grid ui-grid-responsive ui-fluid">
        <div class="ui-g-12">
          <div class="ui-grid-col-2"><label for="sideMenuIcon">Side menu icon</label></div>
          <div class="ui-grid-col-4">
            <p-fileUpload
              id="sideMenuIcon"
              name="myfile[]"
              maxFileSize="300000"
              accept="image/*"
              url="{{ hostname }}/api/supplier/uploadsidemenuicon"
              chooseLabel="Choose"
              uploadLabel="Upload"
              cancelLabel="Cancel"
            >
            </p-fileUpload>
          </div>
        </div>
      </div>
      <form
        [formGroup]="newMobileBrandingForm"
        (ngSubmit)="save(newMobileBrandingForm.value, $event)"
        autocomplete="off"
      >
        <div class="ui-grid ui-grid-responsive ui-fluid">
          <div class="ui-g-12">
            <div class="ui-grid-col-2 test1">
              <label for="backgroundColor">Background color</label>
            </div>
            <div class="ui-grid-col-4">
              <input pInputText id="backgroundColor" formControlName="backgroundColor" />
            </div>
          </div>
          <div class="ui-g-12">
            <div class="ui-grid-col-2">
              <label for="jobListItemColor">Job list item color</label>
            </div>
            <div class="ui-grid-col-4">
              <input pInputText id="jobListItemColor" formControlName="jobListItemColor" />
            </div>
          </div>
          <div class="ui-g-12">
            <div class="ui-grid-col-2">
              <label for="taskListItemColor">Task list item color</label>
            </div>
            <div class="ui-grid-col-4">
              <input pInputText id="taskListItemColor" formControlName="taskListItemColor" />
            </div>
          </div>
          <div class="ui-g-12">
            <div class="ui-grid-col-2">
              <label for="taskDetailsItemColor">Task details item color</label>
            </div>
            <div class="ui-grid-col-4">
              <input pInputText id="taskDetailsItemColor" formControlName="taskDetailsItemColor" />
            </div>
          </div>
          <div class="ui-g-12">
            <div class="ui-grid-col-2"><label for="aboutItemColor">About item color</label></div>
            <div class="ui-grid-col-4">
              <input pInputText id="aboutItemColor" formControlName="aboutItemColor" />
            </div>
          </div>
          <div class="ui-g-12">
            <div class="ui-grid-col-2"><label for="sideMenuTitle">Side menu title</label></div>
            <div class="ui-grid-col-4" style="padding-bottom: 10px">
              <input pInputText id="sideMenuTitle" formControlName="sideMenuTitle" />
            </div>
          </div>
        </div>
        <p-footer>
          <div class="ui-dialog-buttonpane ui-helper-clearfix">
            <button
              type="submit"
              class="btn-to-right"
              pButton
              icon="fa ui-icon-check"
              label="Save"
              [disabled]="newMobileBrandingForm.invalid"
            ></button>
          </div>
        </p-footer>
      </form>
    </div>
  </div>
</div>

<ng-template #loading>Loading...</ng-template>
